import {
  SET_ACTIVE_TAB_ITEM,
  GET_RESORT_DETAIL_SUCCESS,
  SET_RESORT_TAB_ITEM,
  GET_ROOM_DETAIL_SUCCESS,
  GET_DURATION,
  GET_UNIT_CONFIG,
  SET_TOP_AMENITIES,
  FETCH_REVIEW_LANG_LIST_SUCCESS,
  FETCH_TRIP_ADVISOR_REVIEW_SUCCESS,
  FETCH_TRIP_ADVISOR_REVIEW_SUMMARY_SUCCESS,
  RESET_AU,
  SET_DURATION,
  GET_GUEST_DETAIL_SUCCESS,
  GET_UNIT_DETAILS,
  GET_AVAILABLE_DETAILS,
  GET_GUEST_DETAIL_APPLY,
  PRICED_DETAILS_INVOKE_SUCCESS,
  GET_INCLUSIVE_INFO_DETAIL,
  CALCULATE_FEE,
  GET_UNIT_BEFORE_PRICE,
  GET_CALANDER_SELECTED_DATE,
  RESET_AU_CALENDER,
  UPDATE_VISIBLE_UNIT_DETAILS,
  UPDATE_NON_VISIBLE_UNIT_DETAILS,
  RESET_AU_DURATION_CHANGE,
  SET_SEARCH_CRITERIA,
  UPDATE_VISIBLE_UNIT_DETAILS_AFTER_CALCULATE_PRICE,
  TOGGLE_LOADING,
  IS_PRICE_SUCCESS,
  GET_PRICE_FETCH_ERROR,
  GET_UNIT_DETAILS_ERROR,
  GET_UNIT_TYPE_ERROR,
  GET_ROOM_DETIALS_ERROR,
  RESORT_DETAILS_ERROR,
  GET_INCLUSIVE_INFO_ERROR,
  TRIP_ADVISOR_ERROR,
  // DURATION_ERROR,
  ALL_INCLUSIVE_INFO_ERROR,
  ALL_INCLUSIVE_INFO,
  GET_RESORT_DETAILS_ERROR,
  // RESET_AU_FOR_TYPE_HEAD,
  UNIT_DETAILS_INVOKE_SUCCESS,
  AU_HOLD_INVENTORY_STATUS,
  UPDATE_SEARCH_CRITERIA_IN_AU,
  RESET_UNIT_TAB,
  GET_AGGREGATED_AU_SUCCESS,
  GET_AGGREGATED_AU_FAILURE,
  SET_BOOKABLE_VISIBLE_UNITS,
  UPDATE_NONBOOKABLE_UNITS,
  UPDATE_BOOKABLE_UNITS,
  SET_IS_PRICE_SUCCESS
} from './AvailableUnitsConstant';
import {
  groupByDateofUnitDetails,
  groupByDateofUnitAndPriceDetails,
} from './util';

const initialState = {
  isLoading: true,
  activeTab: 'first',
  resortDetailsData: {},
  resortContent: {},
  roomContent: {},
  durationData: {},
  unitType: {},
  topAmenities: [],
  reviewLanguageList: [],
  tripAdvisorReview: {},
  tripAdvisorReviewSummary: {},
  durationDaySelected: '',
  guestDetails: {},
  unitDetails: {},
  guestApplyDetailsPost: {},
  dateWiseUnitDetails: [],
  visibleUnitDetails: [],
  nonVisibleUnitDetails: [],
  availableCalenderData: [],
  isPricedUnitDetailsInvoke: false,
  isDataSyncWithPricedDetails: false,
  inclusiveInfoDetail: {},
  calculateFeeDetail: {},
  selectedDateAndDuration: {},
  searchCriteria: {},
  searchCriteriaFromSearchPage: {},
  isPriceCallSuccess: false,
  priceFetchErrorStatus: false,
  unitDetailsErrorState: false,
  unitTypeErrorStatus: false,
  roomDetailsErrorStatus: false,
  resortDetailsDataErrorStatus: false,
  inclusiveInfoDetailStatus: false,
  tripAdvisorErrorStatus: false,
  // durationErrorStatus: false,
  allInclusiveInfo: {},
  allInclusiveInfoStatus: false,
  resortDetailsErrorStatus: false,
  resetAuForTypeHead: false,
  unitDetailsInvokeSuccess: false,
  holdInventoryStatus: false,
  isUnitTab: false,
  aggregatedResortData: {},
  aggregatedResortError: false,
  bookableUnit: [],
  nonbookableUnit: [],
  bookableVisibleUnit: [],
  bookableNonVisibleUnits: [],
  nonbookableVisibleUnits: [],
  nonbookableNonVisibleUnits: []
};

/**
 * Reducer function for favorites
 * @param {object} state
 * @param {string} action
 */
const AvailableUnitsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_TAB_ITEM: {
      return {
        ...state,
        activeTab: action.payload,
      };
    }
    case TRIP_ADVISOR_ERROR: {
      return {
        ...state,
        tripAdvisorErrorStatus: action.payload,
      };
    }
    case GET_RESORT_DETAIL_SUCCESS:
      return {
        ...state,
        resortDetailsData: action.payload[0] || {},
      };
    case SET_RESORT_TAB_ITEM: {
      return {
        ...state,
        resortContent: action.payload,
      };
    }
    case GET_ROOM_DETAIL_SUCCESS: {
      return {
        ...state,
        roomContent: action.payload,
      };
    }
    case GET_DURATION: {
      return {
        ...state,
        durationData: action.payload,
      };
    }
    case GET_UNIT_CONFIG: {
      return {
        ...state,
        unitType: action.payload,
        isLoading: false,
        unitTypeErrorStatus: false,
      };
    }
    case SET_TOP_AMENITIES: {
      return {
        ...state,
        topAmenities: action.payload,
      };
    }
    case FETCH_REVIEW_LANG_LIST_SUCCESS: {
      return {
        ...state,
        reviewLanguageList: action.payload,
      };
    }
    case FETCH_TRIP_ADVISOR_REVIEW_SUCCESS: {
      return {
        ...state,
        tripAdvisorReview: action.payload,
      };
    }
    case FETCH_TRIP_ADVISOR_REVIEW_SUMMARY_SUCCESS: {
      return {
        ...state,
        tripAdvisorReviewSummary: action.payload,
      };
    }
    case SET_DURATION: {
      return {
        ...state,
        durationDaySelected: action.payload,
      };
    }
    case GET_UNIT_DETAILS: {
      return {
        ...state,
        unitDetails: action.payload,
        dateWiseUnitDetails: groupByDateofUnitDetails(
          action.payload.checkInDateUnitTypeAvailableUnitsMap || [],
          state.selectedDateAndDuration, action.payload.unitTypeCheckInDateMap,
        ),
        isLoading: false,
      };
    }
    case GET_UNIT_BEFORE_PRICE: {
      // const { visibleUnitDetails } = state;
      // // let updatedVisibleUnitDetails = [];
      // // const newlyPricedDetails = groupByDateofUnitDetails(action.payload.checkInDateUnitTypeAvailableUnitsMap);
      // // if (visibleUnitDetails.length) {
      // //   updatedVisibleUnitDetails = [...visibleUnitDetails, ...newlyPricedDetails];
      // // } else {
      // //   updatedVisibleUnitDetails = [...newlyPricedDetails];
      // // }
      return {
        ...state,
        // visibleUnitDetails: groupByDateofUnitDetails(action.payload.checkInDateUnitTypeAvailableUnitsMap),
        visibleUnitDetails: action.payload.checkInDateUnitTypeAvailableUnitsMap
          ? groupByDateofUnitAndPriceDetails(
            action.payload.checkInDateUnitTypeAvailableUnitsMap,
            state.visibleUnitDetails,
          )
          : state.visibleUnitDetails,
        bookableVisibleUnit: action.payload.checkInDateUnitTypeAvailableUnitsMap
        ? groupByDateofUnitAndPriceDetails(
          action.payload.checkInDateUnitTypeAvailableUnitsMap,
          state.bookableVisibleUnit,
        )
        : state.bookableVisibleUnit,
        isPriceCallSuccess: true,
        priceFetchErrorStatus: false,
      };
    }
    case PRICED_DETAILS_INVOKE_SUCCESS: {
      return {
        ...state,
        isPricedUnitDetailsInvoke: action.payload,
      };
    }
    case GET_AVAILABLE_DETAILS: {
      return {
        ...state,
        availableCalenderData: action.payload,
      };
    }
    case GET_CALANDER_SELECTED_DATE: {
      return {
        ...state,
        selectedDateAndDuration: action.payload,
      };
    }
    case GET_GUEST_DETAIL_SUCCESS: {
      return {
        ...state,
        guestDetails: action.payload,
      };
    }
    case GET_GUEST_DETAIL_APPLY: {
      return {
        ...state,
        guestApplyDetailsPost: action.payload,
      };
    }
    case GET_INCLUSIVE_INFO_DETAIL: {
      return {
        ...state,
        inclusiveInfoDetail: action.payload,
        inclusiveInfoDetailStatus: false,
      };
    }
    case CALCULATE_FEE: {
      return {
        ...state,
        calculateFeeDetail: action.payload,
      };
    }
    case RESET_AU_CALENDER: {
      return {
        ...state,
        // unitType: {},
        // unitDetails: {},
        selectedDateAndDuration: action.payload,
        // dateWiseUnitDetails: [],
        // availableCalenderData: [],
        // dateWiseUnitDetails: {},
        isPricedUnitDetailsInvoke: false,
        visibleUnitDetails: [],
        bookableVisibleUnit: [],
        isPriceCallSuccess: false,
        priceFetchErrorStatus: false,
      };
    }
    case UPDATE_VISIBLE_UNIT_DETAILS: {
      return {
        ...state,
        visibleUnitDetails: action.payload,
      };
    }
    case UPDATE_NON_VISIBLE_UNIT_DETAILS: {
      return {
        ...state,
        nonVisibleUnitDetails: action.payload,
      };
    }
    case UPDATE_VISIBLE_UNIT_DETAILS_AFTER_CALCULATE_PRICE: {
      return {
        ...state,
        visibleUnitDetails: action.payload,
      };
    }
    case SET_SEARCH_CRITERIA: {
      return {
        ...state,
        searchCriteria: action.payload,
      };
    }
    case RESET_AU: {
      return {
        ...state,
        resortDetailsData: [],
        resortContent: {},
        roomContent: {},
        durationData: {},
        unitType: {},
        topAmenities: [],
        durationDaySelected: '',
        unitDetails: {},
        availableCalenderData: [],
        guestDetails: {},
        guestApplyDetailsPost: {},
        dateWiseUnitDetails: [],
        isPricedUnitDetailsInvoke: false,
        inclusiveInfoDetail: {},
        calculateFeeDetail: {},
        selectedDateAndDuration: {},
        searchCriteria: {},
        isPriceCallSuccess: false,
        priceFetchErrorStatus: false,
        unitTypeErrorStatus: false,
        roomDetailsErrorStatus: false,
        resortDetailsDataErrorStatus: false,
        inclusiveInfoDetailStatus: false,
        // durationErrorStatus: false,
        allInclusiveInfo: {},
        allInclusiveInfoStatus: false,
        resortDetailsErrorStatus: false,
        holdInventoryStatus: false,
        searchCriteriaFromSearchPage: {},
      };
    }
    case RESET_AU_DURATION_CHANGE: {
      return {
        ...state,
        unitDetails: {},
        availableCalenderData: [],
        // guestDetails: {},
        // guestApplyDetailsPost: {},
        dateWiseUnitDetails: [],
        isPricedUnitDetailsInvoke: false,
        calculateFeeDetail: {},
        selectedDateAndDuration: {},
        visibleUnitDetails: [],
        bookableVisibleUnit: [],
        isPriceCallSuccess: false,
        priceFetchErrorStatus: false,
      };
    }
    case TOGGLE_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case IS_PRICE_SUCCESS: {
      return {
        ...state,
        isPriceCallSuccess: false,
      };
    }
    case GET_PRICE_FETCH_ERROR: {
      return {
        ...state,
        priceFetchErrorStatus: action.payload,
        visibleUnitDetails: [],
        bookableVisibleUnit: []
      };
    }
    case GET_UNIT_DETAILS_ERROR: {
      return {
        ...state,
        unitDetailsErrorState: action.payload,
      };
    }
    case GET_UNIT_TYPE_ERROR: {
      return {
        ...state,
        unitTypeErrorStatus: action.payload,
      };
    }
    case GET_ROOM_DETIALS_ERROR: {
      return {
        ...state,
        roomDetailsErrorStatus: action.payload,
      };
    }
    case RESORT_DETAILS_ERROR: {
      return {
        ...state,
        resortDetailsDataErrorStatus: action.payload,
      };
    }
    case GET_INCLUSIVE_INFO_ERROR: {
      return {
        ...state,
        inclusiveInfoDetailStatus: action.payload,
      };
    }
    // case DURATION_ERROR: {
    //   return {
    //     ...state,
    //     durationErrorStatus: action.payload,
    //   };
    // }
    case ALL_INCLUSIVE_INFO: {
      return {
        ...state,
        allInclusiveInfo: action.payload,
      };
    }
    case ALL_INCLUSIVE_INFO_ERROR: {
      return {
        ...state,
        allInclusiveInfoStatus: action.payload,
      };
    }
    case GET_RESORT_DETAILS_ERROR: {
      return {
        ...state,
        resortDetailsErrorStatus: action.payload,
      };
    }
    // case RESET_AU_FOR_TYPE_HEAD: {
    //   return {
    //     ...state,
    //     unitDetails: {},
    //     availableCalenderData: [],
    //     guestApplyDetailsPost: {},
    //     dateWiseUnitDetails: [],
    //     isPricedUnitDetailsInvoke: false,
    //     inclusiveInfoDetail: {},
    //     calculateFeeDetail: {},
    //     selectedDateAndDuration: {},
    //     isPriceCallSuccess: false,
    //     priceFetchErrorStatus: false,
    //     unitTypeErrorStatus: false,
    //     roomDetailsErrorStatus: false,
    //     resortDetailsDataErrorStatus: false,
    //     inclusiveInfoDetailStatus: false,
    //     // durationErrorStatus: false,
    //     allInclusiveInfo: {},
    //     allInclusiveInfoStatus: false,
    //     resortDetailsErrorStatus: false,
    //   };
    // }
    case UNIT_DETAILS_INVOKE_SUCCESS: {
      return {
        ...state,
        unitDetailsInvokeSuccess: action.payload,
      };
    }
    case AU_HOLD_INVENTORY_STATUS: {
      return {
        ...state,
        holdInventoryStatus: action.payload,
      };
    }
    case UPDATE_SEARCH_CRITERIA_IN_AU: {
      return {
        ...state,
        searchCriteriaFromSearchPage: action.payload,
      };
    }
    case RESET_UNIT_TAB: {
      return {
        ...state,
        isUnitTab: action.payload,
      };
    }
    case GET_AGGREGATED_AU_SUCCESS: {
      return {
        ...state,
        aggregatedResortData: action.payload,
      };
    }
    case GET_AGGREGATED_AU_FAILURE: {
      return {
        ...state,
        aggregatedResortError: action.payload,
      };
    }
    case SET_BOOKABLE_VISIBLE_UNITS: {
      return {
        ...state,
        bookableUnit: action.payload.bookableUnit,
        nonbookableUnit: action.payload.nonbookableUnit,
        bookableVisibleUnit: action.payload.bookableVisibleUnit,
        bookableNonVisibleUnits: action.payload.bookableNonVisibleUnits,
        nonbookableVisibleUnits: action.payload.nonbookableVisibleUnits,
        nonbookableNonVisibleUnits: action.payload.nonbookableNonVisibleUnits
      }
    }
    case UPDATE_NONBOOKABLE_UNITS: {
      return {
        ...state,
        nonbookableVisibleUnits: action.payload.nonbookableVisibleUnits,
        nonbookableNonVisibleUnits: action.payload.nonbookableNonVisibleUnits,
        nonbookableUnit: action.payload.nonbookableUnit,
      }
    }

    case UPDATE_BOOKABLE_UNITS: {
      return {
        ...state,
        bookableVisibleUnit: action.payload.bookableVisibleUnit,
        bookableNonVisibleUnits: action.payload.bookableNonVisibleUnits
      }
    }

    case SET_IS_PRICE_SUCCESS: {
      return {
        ...state,
        isPriceCallSuccess: true,
        isLoading: false,
      }
    }

    default: {
      return state;
    }
  }
};

export default AvailableUnitsReducer;
